import {
  IInsuranceNotCoveredMember,
  IInsurancePolicy,
  InsuranceFamilyPayment,
} from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { IOrder } from '@/common/integrations/menhir/employee/orders/orders.types';
import { IInsuranceOrder } from '@/common/types/catalog';

export const getInsuranceFamilyPaymentType = (
  policy: IInsurancePolicy
): InsuranceFamilyPayment => {
  if (
    policy.settings.payment.child?.company === 1 &&
    policy.settings.payment.spouse?.company === 1
  ) {
    return 'pay_none';
  }
  if (policy.settings.payment.child?.company === 1) {
    return 'pay_spouse';
  }
  if (policy.settings.payment.spouse?.company === 1) {
    return 'pay_child';
  }
  return 'pay_all';
};

export const isInsuranceOrder = (
  order: Pick<IOrder, 'product'>
): order is IInsuranceOrder => order.product.category.slug === 'health';

export const isMemberPaidByCompany = (member: IInsuranceNotCoveredMember) =>
  member.cost.paidByEmployee.amount === 0;

export const canAddFamilyMembersToPolicy = (
  policy: IInsurancePolicy,
  displayFamilyMembersUI: boolean
) => {
  const employee = policy.persons.find((p) => p.type === 'employee');

  return (
    policy.status === 'active' &&
    displayFamilyMembersUI &&
    employee?.status === 'active'
  );
};
